<app-header-style-two-user></app-header-style-two-user>
<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-image" *ngIf="aboutUsPages.img1">
                    <img [src]="createImgPath(aboutUsPages.img1)" class="shadow" alt="">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <!-- <span class="sub-title">{{aboutUsPages?.title}}</span> -->
                    <p  [innerHtml]="aboutUsPages?.shortText">
                    </p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="about-content">
                    <p  [innerHtml]="aboutUsPages?.fullText">
                    </p>
                </div>
            </div>
        </div>
    </div>
    <app-contact-page></app-contact-page>
</div>
<app-footer></app-footer>